// @flow

import React, { Component } from 'react';
import { get } from 'lodash';
import { Query } from 'react-apollo';
import { withRouter, Redirect } from 'react-router-dom';
import type { Location } from 'react-router-dom';
import { parse } from 'qs';
import { connect } from 'react-redux';
import { components } from '@peachjar/components';

import schoolOrDistrictRegistrationQuery from '../utils/schoolOrDistrictRegistration.query';
import VerifyEmailContainer from './VerifyEmailContainer';
import UserRegistrationStateMachine from './UserRegistrationStateMachine';
import UserRegistrationContainer from './UserRegistrationContainer';

const { Spinner, SpinnerLarge } = components.LoadingIndicators;

const pages = [UserRegistrationContainer, VerifyEmailContainer];

type Props = {|
  +location: Location,
  +registrationId: string,
|};

const UserRegistrationQuery = ({ location, registrationId }: Props) => {
  let id;

  if (location.search) {
    const queryParams = parse(location.search, { ignoreQueryPrefix: true });
    // if sales needs to give a customer a link to create their account with
    // a registration already filled out, we can provide the registrationId
    // in the url here
    id = queryParams.regId;
  } else if (registrationId) {
    id = registrationId;
  }

  return (
    <Query query={schoolOrDistrictRegistrationQuery} variables={{ id }}>
      {({ loading, error, data }) => {
        if (loading) {
          return <SpinnerLarge />;
        }

        return (
          <UserRegistrationStateMachine
            loading={loading}
            error={error}
            id={id}
            data={data}
          />
        );
      }}
    </Query>
  );
};

const mapStateToProps = state => ({
  registrationId: state.onboarding.registrationId,
});

export default withRouter(connect(mapStateToProps)(UserRegistrationQuery));



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/UserRegistration/containers/UserRegistrationQuery.jsx